import { IconButton, Menu, MenuItem } from '@material-ui/core';
import React, { useState } from 'react';
import { MdDesktopMac } from 'react-icons/md';
import { MdPictureAsPdf } from 'react-icons/md';
import { FaFileCode } from 'react-icons/fa';

export default function MdfeMenuSimplificado({ 
  data, 
  onBaixarPdf, 
  onBaixarXml
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = async (action) => {
    try {
      switch (action) {
        case 'Baixar PDF':
          if (onBaixarPdf) {
            await onBaixarPdf(data);
          }
          break;
        case 'Baixar XML':
          if (onBaixarXml) {
            await onBaixarXml(data);
          }
          break;
        default:
          break;
      }
      handleClose();
    } catch (error) {
      console.error(`Erro ao executar ação ${action}:`, error);
      handleClose();
    }
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        style={{ padding: '4px', marginLeft: '8px' }}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
      >
        <MdDesktopMac size={17} style={{ color: '#122d58' }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => handleAction('Baixar PDF')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdPictureAsPdf size={18} style={{ color: '#f44336' }} />
          Baixar PDF
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('Baixar XML')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <FaFileCode size={16} style={{ color: '#FF9800' }} />
          Baixar XML
        </MenuItem>
      </Menu>
    </>
  );
}

